import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  menuItem: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: 7
  },
  icon: {
    borderRadius: '8px',
    height: 44,
    width: 44,
    display: 'flex',
    color: '#24378F',
    fontSize: 30,
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all .2s ease-in',
    '&:hover': {
      backgroundColor: '#00A88F',
      transform: 'translateY(-2px)'
    }
  },
  link: {
    color: 'red',
    textDecoration: 'none'
  },
  linkActive: {
    color: '#00A88F',
    '& #panelIcon': {
      backgroundColor: '#00A88F',
      borderRadius: '8px',
      color: 'green'
    },
    '& #bold': {
      fontWeight: 'bold',
      textDecoration: 'none',
      textTransform: 'none'
    }
  },
  linkText: {
    color: '#24378F',
    fontSize: '14px',
    textDecoration: 'none',
    fontFamily: 'Roboto',
    fontWeight: 400
  },
  size: {
    fontSize: 23
  }
}))

export default useStyles
